export const hospitalAccountColumns = [
    'id',
    '_cdc_hash',
    '_cdc_seq',
    'account__admit_date',
    'account__admit_location',
    'account__admit_source_code',
    'account__admit_source_name',
    'account__admit_type_code',
    'account__admit_type_name',
    'account__admitting_physician_code',
    'account__admitting_physician_name',
    'account__admitting_physician_npi',
    'account__admitting_physician_phone',
    'account__attending_physician_code',
    'account__attending_physician_name',
    'account__attending_physician_npi',
    'account__charity_care_flag',
    'account__charity_care_level',
    'account__code_complete_date',
    'account__coding_status_code',
    'account__coding_status_name',
    'account__discharge_date',
    'account__discharge_department',
    'account__discharge_department_code',
    'account__discharge_disposition',
    'account__discharge_disposition_description',
    'account__discharge_facility',
    'account__ecd_number',
    'account__free_text_admitting_cpt',
    'account__free_text_admitting_dx',
    'account__from_date',
    'account__guarantor_account_type',
    'account__guarantor_return_identifiers1',
    'account__guarantor_return_identifiers2',
    'account__guarantor_return_identifiers3',
    'account__hospital_service_code',
    'account__hospital_service_type',
    'account__hospital_service_type_description',
    'account__initial_inpatient_visit_date',
    'account__institutional_flag',
    'account__is_op_recurring_visit',
    'account__mother_account_number',
    'account__patient_class',
    'account__patient_class_name',
    'account__patient_control_number',
    'account__patient_type_code',
    'account__patient_type_name',
    'account__reason_for_visit',
    'account__recurring_indicator',
    'account__referring_physician_code',
    'account__referring_physician_name',
    'account__referring_physician_npi',
    'account__referring_physician_phone',
    'account__registration_id',
    'account__research_flag',
    'account__return_from_agency_amount',
    'account__return_from_agency_date',
    'account__secondary_account_identifier',
    'account__secondary_visit_description',
    'account__service_area_location',
    'account__transfer_to_agency_amount',
    'account__transfer_to_agency_date',
    'account__visit_description',
    'account__visit_grouping_unique_identifier',
    'account__visit_redacted_flag',
    'account__visit_return_identifiers1',
    'account__visit_return_identifiers2',
    'account__visit_return_identifiers3',
    'account_number',
    'combined_accounts__combined_date',
    'combined_accounts__source_account_number',
    'combined_accounts__target_account_number',
    'financial_summary__account_status',
    'financial_summary__additional_payer_payments',
    'financial_summary__amount_transferred_to_collection',
    'financial_summary__bad_debt_balance',
    'financial_summary__bad_debt_eligible_flag',
    'financial_summary__bad_debt_flag',
    'financial_summary__balance_subtotal01',
    'financial_summary__balance_subtotal02',
    'financial_summary__balance_subtotal03',
    'financial_summary__balance_subtotal04',
    'financial_summary__billing_indicator',
    'financial_summary__billing_status_code',
    'financial_summary__billing_status_name',
    'financial_summary__collector_code',
    'financial_summary__current_agency_code',
    'financial_summary__current_financial_class',
    'financial_summary__current_financial_class_description',
    'financial_summary__current_payer_plan_code',
    'financial_summary__do_not_bill_flag',
    'financial_summary__encounter_unbilled_amount',
    'financial_summary__expected_reimbursement',
    'financial_summary__first_billed_date',
    'financial_summary__first_patient_statement_date',
    'financial_summary__guest_pay_eligible_flag',
    'financial_summary__insurance_verification_hold_flags',
    'financial_summary__interest_refund_flag',
    'financial_summary__interest_zero_flag',
    'financial_summary__is_full_self_pay',
    'financial_summary__is_guarantor_eligible',
    'financial_summary__is_visit_eligible',
    'financial_summary__last_insurance_payment_date',
    'financial_summary__last_patient_statement_date',
    'financial_summary__manual_bill_hold_flag',
    'financial_summary__medical_records_coding_hold_flags',
    'financial_summary__medicare_payments',
    'financial_summary__most_recent_bill_date',
    'financial_summary__most_recent_bill_status',
    'financial_summary__on_pre_payment_plan_flag',
    'financial_summary__original_financial_class',
    'financial_summary__original_financial_class_description',
    'financial_summary__other_payments',
    'financial_summary__patient_billing_hold_flag',
    'financial_summary__patient_statement_cycle_code',
    'financial_summary__payment_group',
    'financial_summary__payment_plan_indicator',
    'financial_summary__payment_plan_installment_amount',
    'financial_summary__payment_plan_installment_date',
    'financial_summary__payment_priority_rank',
    'financial_summary__received_financial_care_flag',
    'financial_summary__total_account_balance',
    'financial_summary__total_adjustments',
    'financial_summary__total_charges',
    'financial_summary__total_insurance_adjustments',
    'financial_summary__total_insurance_balance',
    'financial_summary__total_insurance_payments',
    'financial_summary__total_insurance_refunds',
    'financial_summary__total_insurance_takeback',
    'financial_summary__total_patient_balance',
    'financial_summary__total_patient_other_adjustments',
    'financial_summary__total_patient_payments',
    'financial_summary__total_patient_refund',
    'financial_summary__total_payments',
    'financial_summary__trigger_presumptive_charity_scoring_evaluation_flag',
    'financial_summary__visit_statement_unique_identifier',
    'financial_summary__zero_balance_date',
    'fk_hospital__clinical_id',
    'meta_component',
    'meta_correlation_id',
    'meta_lineage_source_name',
    'meta_lineage_source_offset',
    'meta_lineage_source_system_name',
    'meta_load_dt',
    'metadata__correlation_derived_date',
    'metadata__correlation_id',
    'metadata__engagement_id',
    'metadata__engagement_name',
    'metadata__modified_by',
    'metadata__modified_date',
    'metadata__pipeline_id',
    'metadata__pipeline_name',
    'patient__enterprise_medical_record_number',
    'patient__medical_record_number',
    'patient__medicare_hic_number',
    'patient__patient_control_number',
    'patient__patient_id',
    'patient__patient_key',
    'patient__ucrn',
    'r1_id',
    'revint_id',
    'user_defined__user_defined_field1',
    'user_defined__user_defined_field10',
    'user_defined__user_defined_field2',
    'user_defined__user_defined_field3',
    'user_defined__user_defined_field4',
    'user_defined__user_defined_field5',
    'user_defined__user_defined_field6',
    'user_defined__user_defined_field7',
    'user_defined__user_defined_field8',
    'user_defined__user_defined_field9'
];
